import { motion } from "framer-motion";
import { Reveal, Overline } from "@/components/Reveal";
import { PROCESS_STEPS } from "@/lib/constants";

export default function HowItsMade() {
  return (
    <section className="relative bg-black py-24 lg:py-32" data-testid="how-its-made-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <Overline>The Craft</Overline>
          <h2 className="mt-3 max-w-3xl font-display text-5xl leading-none tracking-tight text-cream sm:text-7xl lg:text-8xl">
            HOW IT'S <span className="text-gold-gradient">MADE</span>
          </h2>
          <p className="mt-4 max-w-lg text-white/50">
            Seven deliberate steps between quality ingredients and the crunch you love.
          </p>
        </Reveal>

        <div className="relative mt-16">
          <div className="absolute left-[27px] top-0 hidden h-full w-px bg-gradient-to-b from-gold/60 via-white/10 to-transparent md:block" />
          <div className="space-y-3">
            {PROCESS_STEPS.map((s, i) => (
              <motion.div key={s.title}
                initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.6, delay: i * 0.05 }}
                className="group flex items-center gap-6 rounded-2xl border border-transparent p-4 transition-colors hover:border-white/10 hover:bg-white/[0.03]"
                data-testid={`process-step-${i}`}>
                <div className="relative z-10 grid h-14 w-14 shrink-0 place-items-center rounded-full border border-gold/40 bg-forest-deep font-display text-xl text-gold transition-colors group-hover:gold-gradient group-hover:text-black">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="flex flex-1 flex-col gap-1 md:flex-row md:items-baseline md:gap-6">
                  <h3 className="font-oswald text-2xl uppercase tracking-wide text-cream md:w-72">{s.title}</h3>
                  <p className="text-white/50">{s.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
